export default {
  ICONS: store => {
    return store.icons;
  },
  SELECT_ITEMS: store => {
    return store.selectItems;
  }
};
